/**
 * canSeeFinance — garde de rôle pour l'affichage des données financières
 * (prix, montants, remises, totaux, marges).
 *
 * Convention du codebase : la finance est réservée au rôle 'admin'
 * (cf. user?.role === 'admin' utilisé partout : ListeDetailView, LivraisonView,
 * Ventes, Paiement, Depenses...).
 *
 * Centraliser ici évite de disperser la règle et facilite un futur
 * assouplissement (ex. autoriser aussi 'gerant') en un seul endroit.
 *
 * Usage :
 *   import { useSelector } from 'react-redux';
 *   import canSeeFinance from '../../utils/canSeeFinance';
 *   const user = useSelector((s) => s.user?.currentUser);
 *   {canSeeFinance(user) && <span>{montant} FCFA</span>}
 *
 * @param {object} user  currentUser (state.user.currentUser)
 * @returns {boolean}
 */
export default function canSeeFinance(user) {
  const role = user?.role;
  return role === 'admin';
}

/** Liste des rôles autorisés à voir la finance (source unique). */
export const FINANCE_ROLES = ['admin'];
